<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :clearable="clearable"
            :multiple="multiple"
            :dense="dense"
            :disabled="disabled"
            :outlined="outlined"
            @change="$emit('change', $event)"
            @input="$emit('input', $event)"
            :hideDetails="hideDetails"
            :class="classe"
            :selectAll="selectAll"
            :classe="classe"
            :background-color="backgroundColor"
            :color="color"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectIntegrationShift',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        suppressClear: false,
        // Mapa id-bruto -> id-canonico do grupo (varios cadastros de
        // integration_shifts podem ter o mesmo nome, ex.: "Noturno"
        // duplicado) e id-canonico -> ids do grupo em csv (usado pra
        // filtrar horarios por qualquer um dos ids duplicados).
        rawIdToCanonical: {},
        groupIdsByCanonical: {},
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        maxShift: {
            type: Number,
            default: 3
        },
        dense: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
        shiftId: {

        },
        companyId: {

        },
        hydrating: {
            type: Boolean,
            default: false
        },
        backgroundColor: {},
        color: {},
        
    },
    watch: {
        
        selected(val, oldVal){
            // Ver mesmo comentario em IntegrationHour.vue - o Vuetify pode
            // zerar a selecao momentaneamente quando items e substituido.
            if (val == null && oldVal != null && this.suppressClear) {
                this.selected = oldVal;
                return;
            }

            // Emite todos os ids do grupo (csv) em vez de so o id canonico -
            // o backend (PaginateFilterOrder::filterByCollumns) resolve csv
            // como whereIn, entao o filtro de horarios por turno considera
            // qualquer um dos cadastros duplicados com o mesmo nome.
            const emitted = val != null && this.groupIdsByCanonical[val] ? this.groupIdsByCanonical[val] : val;
            this.$emit('update:model', emitted);
        },

        model(val){
            this.selected = this.resolveCanonical(val);
        },

        shiftId(val){
            if (this.hydrating) return;
            this.getItems();
        },

        companyId(val){
            if (this.hydrating) return;
            this.getItems();
        },

        hydrating(val){
            // Refaz a busca quando o pai termina de hidratar, pra buscar
            // com os filtros finais (evita refetch prematuro que faz o
            // Vuetify perder a selecao atual em meio a hidratacao).
            if (!val) this.getItems();
        },
    },
    methods: {
        ...mapActions('integration', ['ActionIndexIntegrationShifts']),

        // Traduz um id (ou csv de ids ja emitido por este componente) para o
        // id canonico do grupo, pra pre-selecionar corretamente no v-select
        // mesmo quando o "model" recebido do pai referencia um cadastro
        // duplicado que nao e o representante do grupo.
        resolveCanonical(val) {
            if (val == null) return val;

            const first = String(val).split(',')[0];

            return Object.prototype.hasOwnProperty.call(this.rawIdToCanonical, first)
                ? this.rawIdToCanonical[first]
                : val;
        },

        async getItems() {

            this.loading = true;
            this.suppressClear = true;
            let payload = {
                find_columns: {
                    active: 1
                }
            }

            if(this.shiftId){
                payload.find_columns.shift_id = this.shiftId;
            }

            if(this.companyId){
                payload.find_columns.company_id = this.companyId;
            }

            await this.ActionIndexIntegrationShifts(payload)
                    .then((res) => {

                        // Agrupa por nome - pode haver mais de um cadastro de
                        // integration_shifts com o mesmo nome (ex.: mais de
                        // uma filial/nivel de curso usando "Noturno"), e o
                        // select deve exibir cada nome uma unica vez.
                        const groups = [];
                        const groupByName = {};

                        (res.data || []).forEach((row) => {
                            if (!groupByName[row.name]) {
                                groupByName[row.name] = { id: row.id, name: row.name, ids: [] };
                                groups.push(groupByName[row.name]);
                            }
                            groupByName[row.name].ids.push(row.id);
                        });

                        this.items = groups.map((g) => ({ id: g.id, name: g.name }));

                        this.rawIdToCanonical = {};
                        this.groupIdsByCanonical = {};
                        groups.forEach((g) => {
                            g.ids.forEach((id) => { this.rawIdToCanonical[id] = g.id; });
                            this.groupIdsByCanonical[g.id] = g.ids.join(',');
                        });

                        this.selected = this.resolveCanonical(this.model);

                    })
                    .finally(() => {
                        this.loading = false;
                        setTimeout(() => { this.suppressClear = false; }, 100);
                    })
        },
    },
    
}
</script>